import { render, staticRenderFns } from "./MatterFirstInstanceCourtForm.vue?vue&type=template&id=7e4693ce&"
import script from "./MatterFirstInstanceCourtForm.vue?vue&type=script&lang=js&"
export * from "./MatterFirstInstanceCourtForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterFirstInstanceCourtForm.vue?vue&type=style&index=0&id=7e4693ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports